module.exports = __webpack_public_path__ + "static/img/st1.1793b9d2.png";